/* istanbul ignore file */
export const BASE_URL =
  (typeof import.meta !== "undefined" && (import.meta as any)?.env?.VITE_API_BASE_URL) ??
  process.env.VITE_API_BASE_URL ??
  "https://pcs-dev.fujairahport.ae";

export const NOTIF_SERVICE_SEGMENT = "bff-notification";
export const BAY_HIRE_BFF_SERVICE_SEGMENT = "bff-bay-hire";
export const USER_SERVICE_SEGMENT = "bff-user";
// DBCO-0028: bff-drybulk-cargo-ops's servlet context path; resolves through the shared BASE_URL.
export const DRYBULK_CARGO_OPS_BFF_SERVICE_SEGMENT = "bff-drybulk-cargo-ops";

/**
 * Optional, per-service override for the Bay Hire BFF's base URL. Unset by
 * default, so Bay Hire keeps resolving through the shared BASE_URL like
 * every other service. Set VITE_BAY_HIRE_BFF_BASE_URL in a local,
 * git-ignored .env override (e.g. .env.development.local) to point ONLY
 * Bay Hire at a local BFF instance, without touching BASE_URL and therefore
 * without affecting any other service.
 */
export const BAY_HIRE_BFF_BASE_URL: string | undefined =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (typeof import.meta !== "undefined" && (import.meta as any)?.env?.VITE_BAY_HIRE_BFF_BASE_URL) ??
  process.env.VITE_BAY_HIRE_BFF_BASE_URL ??
  undefined;

/**
 * Optional, per-service override for bff-user-service's base URL, same
 * pattern/rationale as BAY_HIRE_BFF_BASE_URL above (DFT-0050 local
 * verification: bff-user-service now mints Bay Hire's SAS tokens via
 * document-service, so exercising the local document-service fix requires
 * routing bff-user calls locally too). Set VITE_USER_SERVICE_BASE_URL in a
 * local, git-ignored .env override to point ONLY bff-user at a local
 * instance, without affecting any other service.
 */
export const USER_SERVICE_BASE_URL: string | undefined =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (typeof import.meta !== "undefined" && (import.meta as any)?.env?.VITE_USER_SERVICE_BASE_URL) ??
  process.env.VITE_USER_SERVICE_BASE_URL ??
  undefined;

/**
 * Optional, per-service override for bff-notification-service's base URL, same pattern and
 * rationale as USER_SERVICE_BASE_URL above.
 *
 * Needed to see locally-generated notifications in the UI at all. Delivery
 * (bay-hire-workflow-worker -> notification-service) never goes through this BFF, so it is
 * unaffected either way - but the bell dropdown and Notifications page read through
 * NOTIF_SERVICE_SEGMENT, which otherwise resolves to the shared dev deployment and therefore to
 * shared dev's notification data, not the rows a local notification-service just wrote. Set
 * VITE_NOTIFICATION_SERVICE_BASE_URL in a local, git-ignored .env override to point ONLY
 * bff-notification at a local instance.
 */
export const NOTIFICATION_SERVICE_BASE_URL: string | undefined =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (typeof import.meta !== "undefined" &&
    (import.meta as any)?.env?.VITE_NOTIFICATION_SERVICE_BASE_URL) ??
  process.env.VITE_NOTIFICATION_SERVICE_BASE_URL ??
  undefined;
